import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { AccordionButton, AccordionItem, AccordionPanel, Box, Flex, Divider, Button, HStack, Input, Text, Image, Accordion, Heading, useColorModeValue, Stack, Avatar, Grid, GridItem } from "@chakra-ui/react";
import axios from "axios";
import PaymentModal from "../Components/PaymentModal";

import React, { useContext, useEffect, useState } from "react";

import { Select, TagLabel } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import SkeletonCart from "../Components/SkeletonCart";

let init = {
    totalPrice: 0,
    subtotal: 0,
    tax: 0,
};

const PaymentOption = ({ cartData, reRenderHook }) => {
    const subtotal = 0;
    let totalPrice = 0;
    cartData.forEach((el) => {
        return (totalPrice = totalPrice + el.qty * el.price);
    });
    const tax = totalPrice * 0.2;

    return (
        <>
            <Box w={"100%"}>
                <Box borderRadius="5px" p={"15px"} boxShadow={"rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"}>
                    <Heading mb={"20px"} fontSize="18px" fontWeight={500}>
                        Order Summary
                    </Heading>
                    <Flex direction="column">
                        <Flex mb={"12px"} justifyContent={"space-between"}>
                            <Text>SubTotal</Text>
                            <Text>${totalPrice}</Text>
                        </Flex>
                        <Divider mb={"12px"} />
                        <Flex mb={"12px"} justifyContent={"space-between"}>
                            <Text>Shipping</Text>
                            <Text>TBD</Text>
                        </Flex>
                        <Divider mb={"12px"} />
                        <Flex mb={"12px"} justifyContent={"space-between"}>
                            <Text>Estimated Tax</Text>
                            <Text>${Math.floor(tax)}</Text>
                        </Flex>
                        <Divider mb={"12px"} />
                        <Flex mb={"12px"} justifyContent={"space-between"}>
                            <Text>Total</Text>
                            <Text>${totalPrice + tax}</Text>
                        </Flex>
                        <Divider mb={"12px"} />

                        <PaymentModal subtotal={subtotal} tax={tax} totalPrice={totalPrice + tax} reRenderHook={reRenderHook} />
                    </Flex>
                </Box>
            </Box>
        </>
    );
};

const Cart = () => {
    const [cartData, setcartdata] = useState([]);
    const [change, setchange] = useState(false);
    const [loading, setloading] = useState(false);
    function reRenderHook() {
        setchange((prev) => !prev);
    }
    async function getdata() {
        try {
            setloading(true);
            let data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/cart`, {
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
            console.log("seccond");
            setloading(false);
            setcartdata(data.data);
        } catch (error) {
            console.log("error in fetching cart data");
        }
    }

    const updateQty = async (id, qty) => {
        try {
            let data = await axios.patch(
                `${process.env.REACT_APP_BACKEND_API}/cart/update/${id}`,
                { qty: +qty },
                {
                    headers: {
                        Authorization: process.env.REACT_APP_TOKEN,
                    },
                }
            );
            getdata();
        } catch (error) {
            console.log("error in update qty");
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_API}/cart/delete/${id}`, {
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
            console.log("first");
            getdata();
        } catch (error) {
            console.log("error in delete");
        } finally{
            window.location.reload();
        }
    };

    useEffect(() => {
        getdata();
    }, [change]);

    return (
        <>
            <Box pt={"20px"} w="95%" m="auto">
                <Flex position={"relative"} direction={{ base: "column", lg: "row" }} justifyContent={{ base: "center", lg: "space-between" }}>
                    <Flex justifyContent={"center"} margin=" 20px auto" w={{ base: "95%", lg: "70%" }}>
                        <Grid
                            m="auto"
                            w="100%"
                            p={"10px"}
                            mt="10px"
                            gap="20px"
                            templateColumns={{
                                base: "repeat(1, 1fr)",
                                md: "repeat(2, 1fr)",
                                lg: "repeat(3, 1fr)",
                            }}
                        >
                            {loading &&
                                new Array(3).fill(0).map(() => {
                                    return <SkeletonCart />;
                                })}
                            {cartData.length == 0 && <EmptyCart />}
                            {cartData?.map((item) => {
                                return (
                                    <GridItem key={item.id} rounded={"md"} boxShadow={"rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"}>
                                        <CartItem cartItem={item} updateQty={updateQty} handleDelete={handleDelete} />
                                    </GridItem>
                                );
                            })}
                        </Grid>
                    </Flex>

                    <Flex w={{ base: "95%", md: "95%", lg: "30%" }} justifyContent={"center"} margin="auto" mt={{ base: "30px", lg: "40px" }} mb="50px" h="600px">
                        <Box w="100%" h="200px" position={{ base: "static", lg: "sticky" }} top={{ base: "0px", md: "150px" }}>
                            <PaymentOption cartData={cartData} reRenderHook={reRenderHook} />
                        </Box>
                    </Flex>
                </Flex>
            </Box>
        </>
    );
};

export default Cart;
// 642892b914f08283594d2c4e

const EmptyCart = () => {
    return (
        <Flex justifyContent={"center"} alignItems={"center"} h="70vh" w="100%">
            <Testimonial>
                <TestimonialContent>
                    <Heading>Cart is Empty</Heading>
                    <TestimonialText w="100%">
                        <Image w="300px" src="cart.png" />

                        <Flex justifyContent={"center"}>
                            <Link to="/">
                                <Button w="200px">Go To Home</Button>
                            </Link>
                        </Flex>
                    </TestimonialText>
                </TestimonialContent>
            </Testimonial>
        </Flex>
    );
};

const Testimonial = ({ children }) => {
    return <Box w="100%">{children}</Box>;
};

const TestimonialContent = ({ children }) => {
    return (
        <Stack
            bg={useColorModeValue("white", "gray.800")}
            boxShadow={"lg"}
            p={8}
            rounded={"xl"}
            align={"center"}
            pos={"relative"}
            _after={{
                content: `""`,
                w: 0,
                h: 0,
                borderLeft: "solid transparent",
                borderLeftWidth: 16,
                borderRight: "solid transparent",
                borderRightWidth: 16,
                borderTop: "solid",
                borderTopWidth: 16,
                borderTopColor: useColorModeValue("white", "gray.800"),
                pos: "absolute",
                bottom: "-16px",
                left: "50%",
                transform: "translateX(-50%)",
            }}
        >
            {children}
        </Stack>
    );
};

const TestimonialHeading = ({ children }) => {
    return (
        <Heading as={"h3"} fontSize={"xl"}>
            {children}
        </Heading>
    );
};

const TestimonialText = ({ children }) => {
    return (
        <Text textAlign={"center"} color={useColorModeValue("gray.600", "gray.400")} fontSize={"sm"}>
            {children}
        </Text>
    );
};

const TestimonialAvatar = ({ src, name, title }) => {
    return (
        <Flex align={"center"} mt={8} direction={"column"}>
            <Avatar src={src} alt={name} mb={2} />
            <Stack spacing={-1} align={"center"}>
                <Text fontWeight={600}>{name}</Text>
                <Text fontSize={"sm"} color={useColorModeValue("gray.600", "gray.400")}>
                    {title}
                </Text>
            </Stack>
        </Flex>
    );
};

const CartItem = ({ cartItem, updateQty, handleDelete }) => {
    const { cart_item: cartlength, checkCartItem } = useContext(CartContext);

    const [qty, setQty] = useState(cartItem.qty);
    const changeTheData = (e) => {
        setQty(e.target.value);
        updateQty(cartItem._id, +e.target.value);
    };

    return (
        <>
            <Box pb={"10px"} borderRadius={"3px"}>
                <Flex justifyContent={"flex-start"} borderTop={"1px solid lightgray"} p="10px" flexDir="column">
                    <Box w="95%" mr="70px" borderRadius={"5px"} border={"1px solid black"} bg="black" boxShadow={"rgba(0, 0, 0, 0.35) 0px 5px 15px;"}>
                        <Flex w="100%" justifyContent={"center"} alignItems="center" h="200px" m="auto">
                            <Image h={"100%"} objectFit="cover" src={cartItem.images[0]} alt={cartItem.title}></Image>
                        </Flex>
                    </Box>
                    <Divider variant="solid" h="10px" colorScheme="purple" orientation="vertical" />
                    <Box mt="20px" mr="20px" w="95%">
                        <Text fontWeight={500}>{cartItem.title}</Text>
                    </Box>
                    <Box mt="20px" mr="30px">
                        {/* <Text>Item Price</Text> */}
                        <Text> Price ${cartItem.price}</Text>
                    </Box>
                    <Flex mt="20px" mr="30px">
                        {/* <Text>Quanitity</Text> */}
                        Qty
                        <Select ml="10px" mt="-5px" placeholder={qty} onChange={changeTheData}>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                        </Select>
                    </Flex>

                    <Box mt="20px" w="100px" mr="70px">
                        {/* <Text>Total Price</Text> */}
                        <Text>Total ${parseInt(cartItem.price) * +cartItem.qty}</Text>
                    </Box>
                    <Box
                        mt="20px"
                        cursor={"pointer"}
                        onClick={() => {
                            checkCartItem();
                            handleDelete(cartItem._id);
                        }}
                        w="5%"
                    >
                        <Button colorScheme="blue">Cancel</Button>
                    </Box>
                </Flex>
            </Box>
        </>
    );
};
